import { QueryClient, useQuery } from "@tanstack/react-query";
import { getRecordingLocalState, RecordingLocalState, saveRecordingLocalState } from "@/repositories/recordingLocalStateRepository";

export const recordingLocalStateQueryKey = (recordingUUID: string) => ["recording-local-state", recordingUUID] as const;

export const setRecordingLocalStateCache = (queryClient: QueryClient, recordingData: RecordingLocalState) => {
  queryClient.setQueryData(recordingLocalStateQueryKey(recordingData.recordingUUID), recordingData);
};

export const persistRecordingLocalState = async (queryClient: QueryClient, recordingData: RecordingLocalState): Promise<void> => {
  await saveRecordingLocalState(recordingData);
  setRecordingLocalStateCache(queryClient, recordingData);
};

export const useRecordingLocalState = (recordingUUID: string) => {
  return useQuery({
    queryKey: recordingLocalStateQueryKey(recordingUUID),
    queryFn: () => getRecordingLocalState(recordingUUID),
    enabled: Boolean(recordingUUID),
    networkMode: "always",
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
